import { Meeting, MeetingPdfStatus } from '../../../types'

export const getConclusionHrefByMeeting = (
  meeting?: Pick<Meeting, 'id' | 'conclusionPdfDownloadToken' | 'conclusionPdfFileName' | 'conclusionPdfStatus'>,
): string | undefined => {
  if (!meeting || meeting.conclusionPdfStatus !== MeetingPdfStatus.FinishedSuccess) {
    return undefined
  }
  return `/api/appraisals/${meeting.id}/conclusion_download/${meeting.conclusionPdfFileName}?downloadToken=${meeting.conclusionPdfDownloadToken}`
}

export const getPreparationPdfHrefByMeeting = (
  meeting?: Pick<Meeting, 'id' | 'preparationPdfStatus' | 'preparationPdfFileName' | 'preparationPdfDownloadToken'>,
): string | undefined => {
  if (!meeting || meeting.preparationPdfStatus !== MeetingPdfStatus.FinishedSuccess) {
    return undefined
  }
  return `/api/preparations/${meeting.id}/preparation_download/${meeting.preparationPdfFileName}?downloadToken=${meeting.preparationPdfDownloadToken}`
}

export const getObjectiveAttachmentHref = (employeeId: string, fileName: string, downloadToken: string): string =>
  `/api/${employeeId}/objective-attachments/${fileName}?downloadToken=${downloadToken}`
